import React from "react";
import Css from "./Certificate.module.css";
import { Link } from "react-router-dom";
import { Certificates } from "../APIS";
const Certificate = () => {
  return (
    <div>
      <div id="certificate" className={Css.parent}>
            <div className={Css.about}>
                <h2><span>Cert</span>ificate</h2>
            </div>
        <div className={Css.container}>
          {Certificates?.map((r) => (
            <div className={Css.cards} key={r.id}>
              <div className={Css.card}>
                <div className={Css.img}>
                  <Link to={`${r.id}`}>
                    <img src={r.image} alt="" />
                  </Link>
                </div>
                <div className={Css.text}>
                  <p>
                    {r.description} <span>{r.span}</span>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Certificate;
